export const formatSourceDate = (value: string) => {
  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date(value));
};

export const humanizeDocumentIdentifier = (value: string) => {
  return value
    .replace(/:\d+$/, '')
    .replace(/^document\.(custom\.)?/, '')
    .replaceAll('.', ' ')
    .replaceAll('_', ' ')
    .replace(/\b\w/g, character => character.toUpperCase());
};

/**
 * The host is the part a reader recognises; the path is what tells two sources on the same site
 * apart. Falls back to the raw string so a malformed URL still renders something.
 */
export const splitUrl = (raw: string) => {
  try {
    const { hostname, pathname, search, hash } = new URL(raw);
    const path = `${pathname}${search}${hash}`.replace(/\/$/, '');
    return { host: hostname.replace(/^www\./, ''), path };
  } catch {
    return { host: raw, path: '' };
  }
};
